module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA20lEQVR4AWMYZmAUjIL/3eLctDO8lVv8VyP3BSCe839VKDN1DW8XUPjVwHX7dwN3++9G7n2/G7hW/1+lzUYdw9t4tIAGPga6vBDMn6/AAeRvBFq0i+Ig+9XEZwo06MWfJu4EFEv3O7D8auBeCLTo+P92fkGyDP/dyOMIDJLXfxp5A7H67P9/RqD8RKDPLv3v4pYgyXCgof4gw4GudybsEK76X41cd/438ysSZ3gTdxzQ8Je/WvjMiA9KnjygRU/+N/FoE0znQC+fgyok0dfcscB4WY4pMwpGwSgAAMIPY8Rw5k5wAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/b1_arrow_up@2x.png
// module id = e3VK
// module chunks = 1